const skuToIgnoreCOD = [] 
const skuToAppendCOD = [] 

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};
